import { ContactPanelBlock as ContactPanelBlockTypes } from '@/payload-types'
import { MapBlock } from '@onclicks/sharedcomponents/defaultTheme/blocks/MapBlock'
import { ContactInformationBlock } from './ContactInformationBlock'
import { SchedulesBlock } from './SchedulesBlock'

const ContactPanelBlock: React.FC<ContactPanelBlockTypes> = (props) => {
  const { content } = props

  if (!content || content.length === 0) return null

  // Les cartes (infos / horaires) d'abord, la carte géographique en dessous
  const cards = content.filter((block) => block.blockType !== 'map')
  const maps = content.filter((block) => block.blockType === 'map')

  return (
    <div className="flex h-full flex-col gap-5">
      {cards.length > 0 && (
        <div className="flex w-full h-full flex-col gap-5 md:flex-row">
          {cards.map((block, index) => (
            <div className="w-full h-full" key={block.id ?? index}>
              {block.blockType === 'contactInformation' && <ContactInformationBlock {...block} />}
              {block.blockType === 'schedulesBlock' && <SchedulesBlock {...block} />}
            </div>
          ))}
        </div>
      )}

      {maps.map(
        (block, index) =>
          block.blockType === 'map' && (
            <div
              key={block.id ?? index}
              className="overflow-hidden rounded-lg border border-primary/40 shadow-2xl"
            >
              <MapBlock {...block} />
            </div>
          ),
      )}
    </div>
  )
}

export { ContactPanelBlock }
